export function formatWithOrdinal(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();

  const suffix = (day % 10 > 3 || Math.floor((day % 100) / 10) === 1)
    ? 'th'
    : ['th', 'st', 'nd', 'rd'][day % 10];

  const monthYear = date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });

  const time = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${day}${suffix} ${monthYear} at ${time}`;
}
